/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAPIHandler from "../hook/use-api-handler";
import { EXIT_FORMALITY_API } from "../pages/employee/exit-formaliti/exit-formality-constant";
import { ORGANIZATION_BENEFIT_API } from "../pages/organization/benefit/benefit-constant";
import { DEPARTMENT_API } from "../pages/organizational-setup/department/department-constant";
import { DESIGNATION_API } from "../pages/organizational-setup/designation/designation-constant";
import { logger } from "../utils/logger";


const EmployeeContext = createContext(null);

export function EmployeeContextProvider({ children }) {
  const [employeeProfileUILoading, setEmployeeProfileUILoading] = useState(false);
  const [employeeInfo, setEmployeeInfo] = useState({});
  // const [employeeID, setEmployeeID] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [employmentTypeList, setEmploymentTypeList] = useState([]);
  const [leaveStating, setLeaveStating] = useState(null)
  const [shiftManagement, setShiftManagement] = useState(null)
  const { fetchData } = useAPIHandler();
  const [isHaveExitFormlity, setIsHaveExitFormlity] = useState(false);


  // useEffect(()=>{
  //  const empID= localStorage.getItem("employeeID");
  //  if(empID){
  //    setEmployeeID(empID)
  //  }
  // },[]);

  const { id: employeeID } = useParams()


  async function getProfileInfoFn(employeeUserID = employeeID) {
    setEmployeeProfileUILoading(true);
    try {
      fetchData({ url: '/employee/' + employeeUserID }).then((res) => {
        setEmployeeInfo(res?.data)
      })
      setEmployeeProfileUILoading(false);

    } catch (error) {
      setEmployeeInfo({});
      setEmployeeProfileUILoading(false);
    }
  }
  async function getBranchListFn() {
    try {
      fetchData({ url: '/organization/org-branch' }).then((res) => {
        setBranchList(res?.data
          ?.filter((it) => it.status === true)
          ?.map(it => ({ id: it?.branch_id, name: it?.branch_name }))
        )
      })

    } catch (error) {
      setBranchList([])
    }
  }
  async function getDepartmentListFn() {
    try {
      fetchData({ url: DEPARTMENT_API.DEPARTMENT_LIST.URL }).then((res) => {
        setDepartmentList(
          res?.data?.departments
            ?.filter((it) => it.status === true)
            ?.map(it => ({ id: it?.department_id, name: it?.deptName }))
        )
      })
    } catch (error) {
      setDepartmentList([])
    }
  }
  async function getDesignationListFn() {
    try {
      fetchData({ url: DESIGNATION_API.DESIGNATION_LIST.URL }).then((res) => {
        setDesignationList(res?.data?.designations
          ?.filter((it) => it.status === true)
          ?.map(it => ({
            id: it?.designationId,
            name: it?.designationName,
            dept_id: it?.dept_id
          }))
        )
      })

    } catch (error) {
      setDesignationList([])
    }
  }

  async function getEmploymentTypeListFn() {
    try {
      fetchData({ url: ORGANIZATION_BENEFIT_API.ORGANIZATION_BENEFIT_GET.url }).then((res) => {
        // setEmploymentTypeList(res?.data?.employmentType?.map(it => ({ id: it, name: it.split('_')
        //   .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        //   .join(' ') })))
        //   setLeaveStating(res?.data?.leave_staging)
        // setShiftManagement(res?.data?.shiftManagement)
        setEmploymentTypeList(res?.data?.employmentType?.map(it => ({
          id: it,
          name: it === 'probationary' ? 'Provision Period' : it === 'full_time' ? 'Parmanent' : it === 'part_time' ? 'Part Time' : it === 'contractual' ? 'Contractual' : it
        })));
        setLeaveStating(res?.data?.leave_staging);
        setShiftManagement(res?.data?.shiftManagement);
      })
    } catch (error) {
      setEmploymentTypeList([])
    }
  }
  const getExitFormality=(employeeID)=>{
    try {
      fetchData({ url:`${EXIT_FORMALITY_API.EXIT_FORMALITY_GET.url}/${employeeID}` }).then((res) => {
        logger.log(res,"exitFormality")
        setIsHaveExitFormlity(res?.data?.exit_formality_id?true:false)
      })
    } catch (error) {
      logger.log(error,"exitFormality-error")
    }
  }

  const [stateList, setStateList] = useState([]);

  useEffect(() => {


    fetchData({ url: "/common/state" }).then((res) => {
      setStateList(
        res?.data?.map((it) => ({
          ...it,

          id: it.state_id,
          name: it.state_name,
        }))
      );
    });
    getBranchListFn();
    getDesignationListFn();
    getDepartmentListFn();
    getEmploymentTypeListFn();
  }, []);

  useEffect(() => {
    if (employeeID) {

      getProfileInfoFn(employeeID)
    }
  }, [employeeID])
  logger.log(isHaveExitFormlity, "isHaveExitFormlity")

  const value = {
    stateList,
    setStateList,
    branchList,
    setBranchList,
    departmentList,
    setDepartmentList,
    designationList,
    setDesignationList,
    employeeInfo,
    setEmployeeInfo,
    employeeProfileUILoading,
    setEmployeeProfileUILoading,
    getProfileInfoFn,
    employeeID,
    employmentTypeList,
    shiftManagement,
    leaveStating,
    getExitFormality,
    isHaveExitFormlity
  };
  return (
    <EmployeeContext.Provider value={value}>{children}</EmployeeContext.Provider>
  );
}

export const useEmployeeContext = () => useContext(EmployeeContext);